import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ReportHistoryTabState, Shipment, ShipmentLocation, StoneReportData } from '@stone/interfaces';

interface ReportsState {
  data: StoneReportData | null;
  loading: boolean;
  history: {
    shipments: ReportHistoryTabState;
    receipts: ReportHistoryTabState;
  };
  purchaseLocations: {
    items: ShipmentLocation[];
    loading: boolean;
  };
  error: string | null;
}

const initialState: ReportsState = {
  data: null,
  loading: false,
  history: {
    shipments: { items: [], totalCount: 0, loading: false, filters: null },
    receipts: { items: [], totalCount: 0, loading: false, filters: null },
  },
  purchaseLocations: { items: [], loading: false },
  error: null,
};

const reportsSlice = createSlice({
  name: 'stone.reports',
  initialState,
  reducers: {
    fetchReportsRequest: (state, _action: PayloadAction<any>) => {
      state.loading = true;
      state.error = null;
    },
    fetchReportsSuccess: (state, action: PayloadAction<StoneReportData>) => {
      state.data = action.payload;
      state.loading = false;
    },
    fetchReportsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchReportHistoryRequest: (state, action: PayloadAction<{ tab: 'shipments' | 'receipts'; params: any }>) => {
      state.history[action.payload.tab].loading = true;
      state.history[action.payload.tab].filters = action.payload.params;
      state.error = null;
    },
    fetchReportHistorySuccess: (state, action: PayloadAction<{ tab: 'shipments' | 'receipts'; items: Shipment[]; totalCount: number }>) => {
      state.history[action.payload.tab].items = action.payload.items;
      state.history[action.payload.tab].totalCount = action.payload.totalCount;
      state.history[action.payload.tab].loading = false;
    },
    fetchReportHistoryFailure: (state, action: PayloadAction<{ tab: 'shipments' | 'receipts'; error: string }>) => {
      state.history[action.payload.tab].loading = false;
      state.error = action.payload.error;
    },
    fetchPurchaseLocationsRequest: (state, _action: PayloadAction<any>) => {
      state.purchaseLocations.loading = true;
      state.error = null;
    },
    fetchPurchaseLocationsSuccess: (state, action: PayloadAction<ShipmentLocation[]>) => {
      state.purchaseLocations.items = action.payload;
      state.purchaseLocations.loading = false;
    },
    fetchPurchaseLocationsFailure: (state, action: PayloadAction<string>) => {
      state.purchaseLocations.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchReportsRequest,
  fetchReportsSuccess,
  fetchReportsFailure,
  fetchReportHistoryRequest,
  fetchReportHistorySuccess,
  fetchReportHistoryFailure,
  fetchPurchaseLocationsRequest,
  fetchPurchaseLocationsSuccess,
  fetchPurchaseLocationsFailure,
} = reportsSlice.actions;
export default reportsSlice.reducer;
